<script lang="ts">
  import SettingsDistributorContacts from "@modern/components/retailer/settings/DistributorContacts/Index.svelte";
  import SettingsDistributorAccountApplications from "@modern/components/retailer/settings/DistributorAccountApplications/Index.svelte";
  import DistributorsStore from "@shared/svelte/Stores/DistributorsStore";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import Spinner from "@shared/svelte/Components/SpinnerInternal.svelte";
  import distributorsServiceFactory from "@shared/services/distributors";
  import qService from "@modern/services/angularjs_shims/q_service";
  import flashFactory from "@shared/services/flash";
  import SettingsPageWrapper from "@modern/components/retailer/settings/PageWrapper.svelte";
  import { params } from "@roxi/routify";
  import LayoutStore from "@shared/svelte/Stores/LayoutStore";
  import type { Distributor } from "@shared/types/Distributor";
  import { isAutoAssignedToRetailer } from "@retailer/services/distributor_service";
  import * as _ from "lodash";
  import UIRouterLink from "@shared/svelte/Components/UIRouterLink.svelte";
  import { getControlStateAuthenticationService } from "@retailer/services/retailer_user_authentications_service";
  import { EventTracking } from "@shared/services/event_tracking/events";

  const load = async () => {
    let distributors = await HttpPromise({
      method: "GET",
      url: "/api/retailer/distributors",
      data: {
        with_integrated: true,
        with_sales_reps: true,
        with_domains: true,
        with_cutoff_time: true,
      },
    });
    DistributorsStore.set(distributors);

    let accountApplications = await HttpPromise({
      url: "api/retailer/account_applications",
      method: "GET",
    });

    let defaultDistributors = await HttpPromise({
      method: "GET",
      url: "/api/retailer/default_distributors",
    });

    return { defaultDistributors, accountApplications };
  };

  // auth service
  const authService = getControlStateAuthenticationService();

  const Distributors = distributorsServiceFactory(null, flashFactory(), qService);

  const { trackClick } = EventTracking;

  var sortDistributors = function (dl) {
    return _.sortBy(dl, function (d) {
      return d.name;
    });
  };

  let assignedDistributors: Distributor[];
  let unassignedDistributors: Distributor[];
  $: {
    assignedDistributors = sortDistributors(
      _.filter($DistributorsStore, function (d) {
        if (isAutoAssignedToRetailer(d)) {
          return false;
        }
        return (d.sales_reps && d.sales_reps.length > 0) || d.retailer_direct_add;
      }),
    );

    const unassignedDistros = () => {
      const unassignedD = _.filter($DistributorsStore, function (d) {
        if (d.retailer_direct_add || d.require_retailer_user_authentication) {
          return false;
        }
        return !d.sales_reps || d.sales_reps.length == 0;
      });
      return _.sortBy(unassignedD, d => d.default_sales_rep);
    };
    unassignedDistributors = _.slice(unassignedDistros(), 0, 3);
  }

  function changeTab(tab) {
    history.pushState(null, "", "/settings/accounts?tab=" + tab);
  }
</script>

{#await load()}
  <Spinner />
{:then { defaultDistributors, accountApplications }}
  <SettingsPageWrapper>
    <div class="fizz-styles">
      <div class="fizz-surface fizz-inset-square-24 fizz-card">
        <div class="fizz-flex-row-responsive fizz-space-between fizz-align-content-start">
          <h3 class="fizz-heading-3 fizz-stack-4">My Distributors</h3>
          <UIRouterLink
            stateName={"layout.distributors"}
            classes="fizz-inset-vertical-8 fizz-text-strong"
            useTrackClick
            eventName="click"
            targetObjectType="my_distributors_see_all_distributors"
          >
            See all distributors
          </UIRouterLink>
        </div>
        <ul class="fizz-tab-list fizz-expand-16">
          <li
            class:fizz-is-active={$params.tab !== "applications"}
            on:click={() => changeTab("connected")}
          >
            {#if $LayoutStore.isMobile}
              Connected
            {:else}
              Connected Distributors
            {/if}
            {#if assignedDistributors.length}
              <span>({assignedDistributors.length})</span>
            {/if}
          </li>
          <li
            class:fizz-is-active={$params.tab === "applications"}
            on:click={() => changeTab("applications")}
          >
            {#if $LayoutStore.isMobile}
              Applications
            {:else}
              Distributor Account Applications
            {/if}
            ({accountApplications.length})
          </li>
        </ul>
        {#if $params.tab === "applications"}
          <SettingsDistributorAccountApplications {accountApplications} />
        {:else}
          <SettingsDistributorContacts
            {assignedDistributors}
            {unassignedDistributors}
            {Distributors}
            {defaultDistributors}
          />
        {/if}
      </div>
    </div>
  </SettingsPageWrapper>
{/await}
<svelte:component this={authService?.authenticationModalComponent} on:update={load} />
